// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"37bb3265","198":"908d0671","404":"c31e8e41"}[chunkId] + ".chunk.js";
};